import React from 'react';

import { useQuery } from '@apollo/client/react';

import { Box, COLORS, FontWeight, Text, ZIndex } from '@clutter/clean';

import { LeadDocument } from '@graphql/platform';

import { useAgentBookingLeadToken } from '@root/components/checkout/helpers/agent_booking';

export const AgentBanner = () => {
  const leadToken = useAgentBookingLeadToken();
  const { data, error } = useQuery(LeadDocument, {
    variables: { token: leadToken! },
    skip: !leadToken,
  });

  if (!leadToken) return null;

  return (
    <Box
      background={COLORS.tiger}
      position="sticky"
      top="0"
      padding="16px"
      minHeight="52px"
      textAlign="center"
      style={{ zIndex: ZIndex.MODAL + 1 }}
    >
      <Text.Callout weight={FontWeight.Medium}>
        {error
          ? 'Attention: You are booking on behalf of an unknown lead, please return to Zendesk to re-open the checkout.'
          : data
            ? `Attention: You are booking on behalf of ${data.lead.name ?? data.lead.email}.`
            : 'Loading'}
      </Text.Callout>
    </Box>
  );
};
